import { Button, Card, Drawer } from '@weezevent/nacre';
import { FormCurrencyInput, FormInput, FormSegmentedControl } from '../../../../../../../components/form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modes } from '../constants';
import { BankAccountSelect, DocumentHeaderSelect, FrequencyField } from './fields';
import classes from '../../../../../style/main.module.scss';
import { useWatch } from 'react-hook-form';
import { PayoutMethods } from '../../constants';
import PropTypes from 'prop-types';

const SHOULD_DISPLAY_NAME = false;

export const PayoutProfileDrawer = ({ isOpen, onClose, mode, onSubmit, isSubmitting }) => {
    const { t } = useTranslation();

    const config = {
        [Modes.CREATE]: {
            title: t('sauron.financeModule.payoutProfiles.drawer.create.title'),
            subtitle: t('sauron.financeModule.payoutProfiles.drawer.create.subtitle'),
            submitCta: t('sauron.financeModule.payoutProfiles.drawer.create.submitCta')
        },
        [Modes.EDIT]: {
            title: t('sauron.financeModule.payoutProfiles.drawer.edit.title'),
            subtitle: t('sauron.financeModule.payoutProfiles.drawer.edit.subtitle'),
            submitCta: t('sauron.financeModule.payoutProfiles.drawer.edit.submitCta')
        }
    };

    const payoutMethod = useWatch({ name: 'payoutMethod' });

    return (
        <Drawer
            classNames={{
                root: classes.drawerRoot
            }}
            open={isOpen}
            onClose={onClose}
            header={<Drawer.Header title={config[mode].title} subtitle={config[mode].subtitle} icon="file" iconOffsets={[0, 1.5]} />}
            footer={
                <Drawer.Footer
                    actions={[
                        <Button as="button" key="cancel" onClick={onClose}>
                            {t('common.cta.cancel')}
                        </Button>,
                        <Button as="button" key="save" primary onClick={onSubmit} isLoading={isSubmitting}>
                            {config[mode].submitCta}
                        </Button>
                    ]}
                />
            }
        >
            <Card>
                <Card.Header>
                    <Card.Title>{t('sauron.financeModule.payoutProfiles.drawer.card.title')}</Card.Title>
                </Card.Header>
                <Card.Content>
                    {SHOULD_DISPLAY_NAME && (
                        <FormInput
                            name="name"
                            label={t('sauron.financeModule.payoutProfiles.drawer.fields.name.label')}
                            placeholder={t('sauron.financeModule.payoutProfiles.drawer.fields.name.placeholder')}
                            required
                        />
                    )}
                    <FormSegmentedControl
                        name="payoutMethod"
                        options={[
                            {
                                text: t('sauron.financeModule.payoutProfiles.drawer.fields.payoutMethod.options.frequency'),
                                value: PayoutMethods.FREQUENCY
                            },
                            {
                                text: t('sauron.financeModule.payoutProfiles.drawer.fields.payoutMethod.options.payoutThreshold'),
                                value: PayoutMethods.PAYOUT_THRESHOLD
                            }
                        ]}
                    />
                    {payoutMethod === PayoutMethods.FREQUENCY && <FrequencyField name="frequency" required />}
                    {payoutMethod === PayoutMethods.PAYOUT_THRESHOLD && (
                        <FormCurrencyInput
                            label={t('sauron.financeModule.payoutProfiles.drawer.fields.payoutThreshold.label')}
                            placeholder={t('sauron.financeModule.payoutProfiles.drawer.fields.payoutThreshold.placeholder')}
                            name="payoutThreshold"
                            required
                        />
                    )}
                    <BankAccountSelect name="bankAccount" required />
                    <DocumentHeaderSelect name="documentHeader" required />
                    <FormCurrencyInput
                        label={t('sauron.financeModule.payoutProfiles.drawer.fields.reserve.label')}
                        placeholder={t('sauron.financeModule.payoutProfiles.drawer.fields.payoutThreshold.placeholder')}
                        name="reserve"
                    />
                </Card.Content>
            </Card>
        </Drawer>
    );
};

PayoutProfileDrawer.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(Object.values(Modes)).isRequired,
    onSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool
};
